import React, { useState, useEffect, useRef } from 'react';

// Import the single combined image for the circular graphics.
import combinedCirclesImage from '../assets/960-panolux-about-01.jpg';

function HakkimizdaSection() {
  const [isVisible, setIsVisible] = useState(false);
  const imageRef = useRef(null);

  useEffect(() => {
    // imageRef.current değerini bir değişkene kopyala
    const currentImageRef = imageRef.current;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            // Gözlemlemeyi durdurmak için kopyalanan ref'i kullan
            if (currentImageRef) { // null kontrolü ekledim
                observer.unobserve(entry.target);
            }
          }
        });
      },
      {
        threshold: 0.3,
      }
    );

    // Observer'ı başlatmak için kopyalanan ref'i kullan
    if (currentImageRef) {
      observer.observe(currentImageRef);
    }

    // Cleanup fonksiyonu: observer'ı durdurmak için kopyalanan ref'i kullan
    return () => {
      if (currentImageRef) {
        observer.unobserve(currentImageRef);
      }
    };
  }, []); // Bağımlılık dizisi boş bırakıldı, sadece bir kez çalışacak

  return (
    <section
      id="hakkimizda"
      className="py-16 bg-white flex flex-col items-center justify-center min-h-screen px-4 sm:px-6 lg:px-8 font-sans"
    >
      {/* Section Header */}
      <header className="text-center mb-8">
        <h2 className="text-2xl sm:text-3xl font-light text-gray-800 tracking-wide">
          Panolux Nedir?
        </h2>
        <div className="w-16 h-1 bg-black mt-2 mx-auto"></div> {/* Underline effect */}
      </header>

      {/* Section Content */}
      <div className="max-w-3xl text-center mb-10">
        <p className="text-sm sm:text-base text-gray-600 leading-relaxed font-light">
          Panolux, Fibrosan tarafından geliştirilen üstün teknik özelliklere sahip CTP panel sistemidir.
          Dev projelerden konut veya ofis mimarisine kadar her alanda kullanılabilir.
          <span className="font-normal text-gray-700"> Işık geçirgenliği</span> ve
          <span className="font-normal text-gray-700"> çok yüksek mekanik performansı</span> ile mimar ve tasarımcıların
          yeni gözdesidir.
        </p>
      </div>

      {/* Visual Representation */}
      <figure
        ref={imageRef}
        className={`mb-8 transform transition-all duration-1000 ease-out ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}
      >
        <img
          src={combinedCirclesImage}
          alt="Panolux'un temel özelliklerini temsil eden üç dairesel görsel"
          className="max-w-full h-auto "
        />
        <figcaption className="sr-only">Panolux'un temel özelliklerini temsil eden dairesel grafikler.</figcaption>
      </figure>
    </section>
  );
}

export default HakkimizdaSection;